import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import DepartmentAdd from "@/views/MGT/member/components/department-add.vue";
import VirtualTree from "@/components/pro-common/pro-page-tree/virtual-tree.vue";
import { departmentTree, deleteOrganizationById } from "@/service/structure";
import _ from "lodash";
export default {
  name: "member-tree",
  components: {
    DepartmentAdd,
    VirtualTree
  },
  data() {
    return {
      departmemt: {
        visible: false,
        edit: false,
        node: {}
      },
      searchValue: "",
      treeData: [],
      debouncedSearch: _.debounce(this.onSearch, 500)
    };
  },
  computed: {
    _searchPlaceholder() {
      // 使用简单变量作为 gc-i18n 的插值参数，避免复杂表达式被当成占位符名称。
      const departmentName = this.departmemt.node.name || $t("dv7d2", "企业");
      return $t("vkzhh4y", "\u67E5\u201C${departmentName}\u201D\u4E0B\u7684\u624B\u673A\u53F7\u3001\u59D3\u540D\u3001\u5DE5\u53F7\u3001\u90AE\u7BB1", {
        "departmentName": departmentName
      });
    }
  },
  mounted() {
    this.initial();
  },
  methods: {
    async initial() {
      await this.getTreeData();
      this.setInitNode();
    },
    async getTreeData() {
      this.$emit("onChangeLoading", true);
      let {
        data
      } = await departmentTree();
      this.$emit("onChangeLoading", false);
      if (data && data.result === 0) {
        let treeData = [data.retVal];
        this.DGTree(treeData);
        this.treeData = treeData;
        if (this.treeData.length === 0) {
          this.searchValue = "";
          this.departmemt.node = {};
        }
      }
    },
    setInitNode() {
      if (this.treeData[0]) {
        this.departmemt.node = this.treeData[0];
        this.departmemt.node.checked = true;
        this.$emit("onChange", this.departmemt.node);
      }
    },
    DGTree(arr, level = 0) {
      arr.forEach(v => {
        v.expand = true;
        v.checked = false;
        v.level = level;
        if (v.children && v.children.length > 0) {
          this.DGTree(v.children, level + 1);
        }
      });
    },
    onChange(node) {
      this.departmemt.node.checked = false;
      node.checked = true;
      this.departmemt.node = node;
      this.$emit("onChange", node);
    },
    onDelete(node) {
      this.$Modal.confirm({
        title: $t("eslg2", "删除"),
        loading: true,
        content: `${$t('8ddcgw5', '确认删除：')}${node.name}？`,
        onOk: async () => {
          const params = {
            id: node.id
          };
          let res = await deleteOrganizationById(params);
          if (res.data && res.data.result === 0) {
            this.$Message.success($t("azeh8z4", "删除成功"));
            this.initial();
          }
          this.$Modal.remove();
        }
      });
    },
    onAddDepartmemt(node) {
      this.departmemt.node = node;
      this.departmemt.edit = false;
      this.departmemt.visible = true;
    },
    onEditDepartmemt(node) {
      this.departmemt.node = node;
      this.departmemt.edit = true;
      this.departmemt.visible = true;
    },
    onChangeSearch() {
      this.debouncedSearch();
    },
    onSearch() {
      this.$emit("onSearch", this.searchValue);
    },
    async onSuccessEdit() {
      await this.getTreeData();
      let node = {};
      let change = arr => {
        arr.forEach(v => {
          if (v.orgId === this.departmemt.node.orgId) {
            node = v;
          } else {
            if (v.children && v.children.length > 0) {
              change(v.children);
            }
          }
        });
      };
      change(this.treeData);
      this.onChange(node);
    }
  }
};